import { intersection } from 'ramda'

import { Questionnaire, QuestionnaireMessages } from '@karakuri-web/faq-type'

const defaultNotSelected = '上記Q＆Aは参考になりましたか?'

/**
 * @see https://www.notion.so/karagram/smartFAQ-143e6e307bcb8038931ce332d382982e?pvs=4#143e6e307bcb80b494f0f3277d44d314
 * チャットボットのフィーバック機能と同じ仕様とする
 */
export function generateQuestionnaireMessages(
  questionnaire: Questionnaire | null | undefined,
  cardTags: ReadonlyArray<string>
): QuestionnaireMessages {
  const commonMessages = {
    notSelected: questionnaire?.notSelected || defaultNotSelected,
    yes: questionnaire?.yes || '',
    no: questionnaire?.no || '',
    yesForm: questionnaire?.yesForm || '',
    noForm: questionnaire?.noForm || '',
  }

  const unwrapQuestionnaireTagEntries = questionnaire?.tagEntries
  if (!unwrapQuestionnaireTagEntries) return commonMessages

  const sortedQuestionnaireTags = [...unwrapQuestionnaireTagEntries]
    .sort((a, b) => a.priority - b.priority)
    .map(x => x.tag)

  if (intersection(cardTags, sortedQuestionnaireTags).length > 0) {
    const matchedTag = intersection(cardTags, sortedQuestionnaireTags)[0]
    const entry = unwrapQuestionnaireTagEntries.find(x => x.tag === matchedTag)
    return {
      notSelected: entry?.notSelected || defaultNotSelected,
      yes: entry?.yes || '',
      no: entry?.no || '',
      yesForm: entry?.yesForm || '',
      noForm: entry?.noForm || '',
    }
  }

  return commonMessages
}
